import { useNavigate } from 'react-router-dom';
import classes from './Taxrate.module.css';
import NewCostAndRevenueForm from '../components/Bookings/NewCostAndRevenueForm';
import PostAPI from '../api/PostAPI';

export default function NewCostAndRevenuePage() {
    const navigate = useNavigate();
    const PAGE_URL = 'costandrevenue';
    async function storeNewHandler(newData) {
        await PostAPI(PAGE_URL, newData)
            .then((result) => {
                navigate("/costandrevenue");
            })
            .catch((err) => {
                console.log(err)
            });
    }

    return (
        <div className={classes.tax}>
            <h1>Create New Taxrate</h1>
            <NewCostAndRevenueForm onStoreNew={storeNewHandler} />
        </div>
    );
}